import { useState, useCallback, createContext, useContext } from 'react';

var NotifyContext = createContext(null);

export function useNotify() {
  return function(msg, opts) {
    // Simple non-blocking notification
    var div = document.createElement('div');
    var bg = (opts && opts.variant === 'error') ? '#c0392b' : 
             (opts && opts.variant === 'success') ? '#27ae60' : '#1a5276';
    div.style.cssText = 'position:fixed;bottom:20px;right:20px;padding:12px 24px;background:' + bg + 
      ';color:white;border-radius:8px;z-index:9999;font-family:Inter,sans-serif;font-size:14px;box-shadow:0 4px 12px rgba(0,0,0,0.15);transition:opacity 0.3s;';
    div.textContent = msg;
    document.body.appendChild(div);
    setTimeout(function() { div.style.opacity = '0'; setTimeout(function() { div.remove(); }, 300); }, 3000);
  };
}

// Compatibility shim for code that imports useSnackbar from notistack
export function useSnackbar() {
  var notify = useNotify();
  return { enqueueSnackbar: notify };
}
